import { Form, Link, Text } from '@domain-group/suit-theme'

import EntitySelector from '@components/EntitySelector'

import useBrandGroupPublications from '@hooks/useBrandGroupPublications'

import useCreateBrandGroupPublicationModal from '../../hooks/useCreateBrandGroupPublicationModal'

interface SelectBrandGroupProps {
  isTopModal: boolean,
  modalHookPayload: ReturnType<typeof useCreateBrandGroupPublicationModal>,
}

const SelectBrandGroup = (props: SelectBrandGroupProps) => {
  const { isTopModal, modalHookPayload } = props

  const {
    callbacks: {
      addBrandGroupProvider,
      addBrandProvider,
      handleBrandSelector,
    },
    brandId,
    brandGroupPublicationFormPayload,
    filteredBrandGroups,
    publication,
  } = modalHookPayload

  const {
    entityState: {
      brand_group_id,
    },
    errors,
    handlers,
  } = brandGroupPublicationFormPayload

  const {
    filteredBrandGroupPublications,
  } = useBrandGroupPublications({ filters: { publication_id: publication.id } })

  const assignedBrandGroupIds = filteredBrandGroupPublications.map(item => item.brand_group_id)

  const unassignedBrandGroups = filteredBrandGroups.filter(bg => (
    // @ts-expect-error TS2339
    !assignedBrandGroupIds.includes(bg.id) && bg.provider_ids?.includes(publication.provider_id)
  ))

  return (
    <>
      <EntitySelector
        boxProps={{ marginBottom: 'large' }}
        callbacks={{
          // @ts-expect-error TS2345
          selectItem: brand => handleBrandSelector(brand),
        }}
        entityKey="brands"
        errorMessage={errors.brand_id}
        label="* Brand"
        requestOptions={{
          include_brand_brand_groups: true,
        }}
        searchForwardProps={{
          listAction: (
            // @ts-expect-error TS2741
            <EntitySelector.CreateEntity
              onClick={() => addBrandProvider()}
              strings={{ create: 'Assign to Provider to enable' }}
            />
          ),
        }}
        searchRequestOptions={{
          assigned_provider_id: publication.provider_id,
        }}
        // @ts-expect-error TS2322
        selectedItemId={brandId}
        shouldRefetch={isTopModal}
      />

      {brandId && (
        <Form.Field
          errorMessage={errors.brand_group_id}
          label="* Brand Group"
        >
          {/*
           // @ts-expect-error TS2322 */}
          <select
            name="brand_group_id"
            value={brand_group_id}
            {...handlers}
          >
            <option value="">Please Select...</option>
            {unassignedBrandGroups.map(brandGroup => (
              <option key={brandGroup.id} value={brandGroup.id}>
                {brandGroup.title}
              </option>
            ))}
          </select>

          <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="medium">
            Can't find it?&nbsp;
            <Link
              onClick={() => addBrandGroupProvider({
                brandId, brandGroupProvider: { provider_id: publication.provider_id },
              })}
            >
              Enable Brand Group for Provider
            </Link>
          </Text>
        </Form.Field>
      )}
    </>
  )
}

export default SelectBrandGroup
